<template>
    <div class="card-select">
        <div
            v-for="(option, index) in options"
            :key="index"
            class="card-select-option"
            :class="{
                'deactivated-card-select-option': !option.selectable,
            }"
            v-tooltip.bottom="
                !option.selectable
                    ? 'Esta integração não está ativa para sua conta, para ativá-la entre em contato com nossa equipe.'
                    : ''
            "
            @click="emitOption(option.value)"
        >
            <img :src="option.image" :style="option.imageStyle" />
            <p class="card-select-option-text">{{ option.text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            Type: Array,
            default: () => [],
        },
    },

    methods: {
        emitOption(optionVal) {
            this.$emit("selected", optionVal);
        },
    },
};
</script>

<style lang="scss" scoped>
.card-select {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    .card-select-option {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 120px;
        border: 1px solid gray;
        flex-direction: column;
        gap: 8px;
        padding: 0.25rem;
        border-radius: 0.5rem;
        flex-shrink: 0;

        img {
            width: 50px;
            height: 50px;
        }

        .card-select-option-text {
            margin: 0;
            text-align: center;
        }
    }

    .deactivated-card-select-option {
        filter: grayscale(100%);
        background-color: rgba(156, 163, 175, 0.2);
        user-select: none;
        cursor: not-allowed;
    }
}
</style>
